import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { useState } from "react";
import React from "react";
import Beaker from "../images/BeakerIsolated.png";
import Chlorella from "../images/Ingredients/Chlorella.png";
import ChlorellaBg from "../images/Ingredients/Chlorella-1440.jpg";
import FiberSmartBg from "../images/Ingredients/FiberSmart-1440.jpg";
import FiberSmart from "../images/Ingredients/FiberSmart-Tapioca.png";
import GingerRoot from "../images/Ingredients/GingerRoot.png";
import GingerRootBg from "../images/Ingredients/GingerRoot-1440.jpg";
import Ginseng from "../images/Ingredients/Ginseng.png";
import GinsengBg from "../images/Ingredients/Ginseng-1440.jpg";
import Inulin from "../images/Ingredients/Inulin.png";
import InulinBg from "../images/Ingredients/Inulin-1440.jpg";
import LTheanine from "../images/Ingredients/L-Theanine.png";
import LTheanineBg from "../images/Ingredients/L-Theanine-1440.jpg";
import LionsMane from "../images/Ingredients/LionsMane.png";
import LionsManeBg from "../images/Ingredients/LionsMane-1440.jpg";
import Spirulina from "../images/Ingredients/Spirulina.png";
import SpirulinaBg from "../images/Ingredients/Spirulina-1440.jpg";
import styles from "./styles.module.scss";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
import { useScreenWidth } from "Root/quiz/hooks/useScrollHook";
import DrawerComponent from "Root/profile/components/common/DrawerComponent";
import RhodeFont from "Root/profile/components/common/RhodeFont";
const ingredients = [
    {
        title: "Spirulina, Wheatgrass, Kale",
        name: "spirulina",
        img: Spirulina,
    },
    {
        title: "Prebiotic Fibers (Inulin)",
        name: "inulin",
        img: Inulin,
    },
    {
        title: "lION’S MANE",
        name: "lions-mane",
        img: LionsMane,
    },
    {
        title: "L-THEANINE",
        name: "l-theanine",
        img: LTheanine,
    },
    {
        title: "CHLORELLA",
        name: "chlorella",
        img: Chlorella,
    },
    {
        title: "FiberSmart®",
        name: "fiberSmart",
        img: FiberSmart,
    },
    {
        title: "GINGER ROOT",
        name: "ginger-root",
        img: GingerRoot,
    },
    {
        title: "Grape Seed Extract",
        name: "grapeseed",
        img: Ginseng,
    },
];
const ingredientContent = {
    spirulina: {
        title: "SPIRULINA, WHEATGRASS & KALE",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "Spirulina" }), ": A powerhouse blue-green algae, packed with amino acids, antioxidants, fatty acids, and a variety of essential phytonutrients."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Wheat Grass" }), ": A nutrient-rich plant that brings a multitude of health benefits to your daily diet."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Kale" }), ": A leafy green renowned for its vitamin and mineral content, supporting overall well-being."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": Our greens are more than just vegetables; they're a blend of nature's best, ensuring you get a wide range of essential nutrients, antioxidants, and vitamins that", " ", _jsx("b", { children: "support heart health, reduce disease risk, and keep your mind sharp as you age" }), "."] }),
        ],
        image: SpirulinaBg,
    },
    "lions-mane": {
        title: "Lion’s Mane",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "Hericium Erinaceus" }), ": Widely known as lion\u2019s mane, is an edible mushroom valued in Traditional Chinese Medicine for its benefits to the digestive and nervous systems. Rich in vitamins and minerals, it has been traditionally utilized for gastric conditions due to its anti-inflammatory properties and ability to regenerate gastrointestinal mucosa."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": In addition to anti-inflammatory properties, Lion\u2019s mane also", " ", _jsx("b", { children: "supports cognition, focus, creativity, and productivity" }), ". Studies have also shown improvement in individuals with mood disorders, enhanced memory, and", " ", _jsx("b", { children: "neuroprotection against cognitive diseases, such as Alzheimer's" }), "."] }),
        ],
        image: LionsManeBg,
    },
    "l-theanine": {
        title: "L-THEANINE",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: " L-theanine" }), ": An amino acid prevalent in green tea leaves and often consumed in beverages, is known for its ability to relax the mind without causing drowsiness by significantly increasing activity in the alpha frequency band. It can cross the blood-brain barrier, with most studies highlighting its potential to promote relaxation."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": When combined with caffeine, L-theanine can enhance performance on cognitively demanding tasks,", " ", _jsx("b", { children: "improve alertness and focus, reduce stress-related symptoms, and improve the quality of sleep" }), "."] }),
        ],
        image: LTheanineBg,
    },
    chlorella: {
        title: "Chlorella",
        subtitle: "(ChlorelIa Pyrenoidosa)",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "Chlorella" }), ": A green algae that grows in fresh water, contains high levels of proteins, chlorophylls, vitamins, minerals, and dietary fibers."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": We need our immune system to function properly to protect us against germs and foreign species to our bodies, to prevent infections.Apart from everyday health, maintaining a strong immune system becomes even more critical during periods of rigorous training. Intense physical activity can reduce salivary SIgA levels, temporarily weakening the immune defense and heightening the risk of infection.", " ", _jsx("b", { children: "Therefore, individuals with demanding exercise routines should prioritize immune support" }), "."] }),
        ],
        image: ChlorellaBg,
    },
    fiberSmart: {
        title: "FiberSMART® Soluble Tapioca Fiber Powder",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "FiberSMART\u00AE Soluble Tapioca Fiber Powder" }), ": A dietary fiber sourced from tapioca, made from the cassava root, is known as a resistant dextrin, comprising DP3 and higher polymers. It is not completely digested, so it has the characteristics of fermentability and increased absorption of minerals. When consumed with a meal, it forms a viscous gel in the stomach."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: " Why it\u2019s important" }), ": Fiber reduces the glycemic response to carbohydrate-rich foods, supporting a healthy gut microbiome for efficient digestion and nutrient absorption, and lowering the risk of digestive disorders."] }),
        ],
        image: FiberSmartBg,
    },
    grapeseed: {
        title: "Grape Seed Extract",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "Grape Seed Extract" }), ": Derived from wine grape seeds, is celebrated for its potent antioxidants, particularly oligomeric proanthocyanidin complexes (OPCs). These antioxidants may aid in managing hypertension or high blood pressure by protecting blood vessels from damage, which can otherwise contribute to increased blood pressure. Animal studies have shown significant reductions in blood pressure with the use of grape seed extract."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": Grape seed extract helps modulate blood pressure, thereby influencing stress perception and potentially reducing the feeling or perception of stress."] }),
        ],
        image: GinsengBg,
    },
    inulin: {
        title: "PREBIOTIC FIBERS (INULIN)",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "Inulin" }), ": A type of prebiotic soluble fiber found in certain plants, and in this case, is derive from Jerusalem Artichoke. Inulin contributes to our total recommended daily intake of fiber and supports your immune system function by produces Short Chain Fatty Acids."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": Getting sufficient dietary fiber", " ", _jsx("b", { children: "helps protect against cardiovascular diseases and some cancers" }), ". Inulin also bolsters immune function by producing Short Chain Fatty Acids, crucial for defending against infections and particularly beneficial for those with intense training schedules, as heavy exercise can temporarily weaken immune defenses."] }),
        ],
        image: InulinBg,
    },
    "ginger-root": {
        title: "GINGER ROOT",
        subtitle: "",
        description: [
            _jsxs(RegFont, { children: [_jsx("b", { children: "Ginger Root (Zingiber Officinale):" }), " A flavorful root used both as a spice and in folk medicine, is renowned for alleviating digestive problems such as nausea, vomiting, and gas, making it a tasty solution for stomach discomfort."] }),
            _jsxs(RegFont, { children: [_jsx("b", { children: "Why it\u2019s important" }), ": Ginger provides digestive support through enhancing the gastric emptying rate to sooth the stomach,", " ", _jsx("b", { children: "promoting a happier gut for improved overall health" }), "."] }),
        ],
        image: GingerRootBg,
    },
};
const GreensIngredients = () => {
    const [currentIngredient, setCurrentIngredient] = useState("");
    const [openDrawer, setOpenDrawer] = useState(false);
    const isMobile = useScreenWidth() < 968;
    const toggleDrawer = (value) => () => {
        setOpenDrawer(value);
    };
    const onClick = (ingredient) => {
        setCurrentIngredient(ingredient);
        setOpenDrawer(true);
    };
    return (_jsxs("div", { className: styles.ingredients_wrapper, children: [_jsxs("div", { className: styles.title, children: [_jsx(Eyebrow, { children: "Our Ingredients" }), _jsx(H2Font, { children: "Know What You're Getting with Each Scoop" }), _jsx(RegFont, { children: "Trust you're giving your body the best, with recipe transparency of powerful ingredients." })] }), _jsx("div", { className: styles.ingredients, children: _jsxs("div", { className: styles.beaker_wrapper, children: [_jsx("img", { className: styles.bg_img, src: Beaker, alt: "greens" }), ingredients.map((item, i) => (_jsxs("div", { className: cx(styles.ingredient_content, styles[`ingredient_content-` + item.name]), onClick: () => onClick(item.name), children: [i % 2 !== 0 && (_jsx(RhodeFont, { style: {
                                        fontSize: isMobile ? "10px" : "12px",
                                        fontWeight: 500,
                                        letterSpacing: "2px",
                                        lineHeight: "16px",
                                    }, children: item.title.toUpperCase() })), _jsx("div", { className: cx(styles.img_wrapper, i === 0 && styles.shine), children: _jsx("img", { src: item.img, alt: item.title }) }), i % 2 === 0 && (_jsx(RhodeFont, { style: {
                                        fontSize: isMobile ? "10px" : "12px",
                                        fontWeight: 500,
                                        letterSpacing: "2px",
                                        lineHeight: "16px",
                                    }, children: item.title.toUpperCase() }))] }, item.name)))] }) }), _jsx(DrawerComponent, { extraClassName: styles.drawer_header, toggleDrawer: toggleDrawer, open: openDrawer, crossButton: true, children: _jsxs("div", { className: styles.drawer, children: [_jsxs("div", { className: styles.drawer_title, style: {
                                backgroundImage: `url(${currentIngredient &&
                                    ingredientContent[currentIngredient].image})`,
                            }, children: [_jsx(RhodeFont, { style: {
                                        fontSize: "30px",
                                        color: ["spirulina", "chlorella", "inulin"].includes(currentIngredient)
                                            ? "#fff"
                                            : "#333",
                                        fontWeight: 500,
                                        lineHeight: "36px",
                                    }, children: currentIngredient &&
                                        ingredientContent[currentIngredient]?.title }), currentIngredient &&
                                    ingredientContent[currentIngredient]?.subtitle && (_jsx(RhodeFont, { style: {
                                        fontSize: "24px",
                                        color: ["spirulina", "chlorella", "inulin"].includes(currentIngredient)
                                            ? "#fff"
                                            : "#333",
                                        fontWeight: 500,
                                        lineHeight: "36px",
                                    }, children: currentIngredient &&
                                        ingredientContent[currentIngredient]?.subtitle }))] }), _jsx("div", { className: styles.content, children: currentIngredient &&
                                ingredientContent[currentIngredient]?.description.map((item, i) => (_jsxs(React.Fragment, { children: [_jsx(RegFont, { children: item }), i === 0 && _jsx("hr", { color: "#DAD2C6" })] }, i))) })] }) })] }));
};
export default GreensIngredients;
